import { List, Row, Col, Typography, Button, Space, Tag, Spin, Empty } from 'antd';
import { DownloadOutlined, BookOutlined, CalendarOutlined, IdcardOutlined, ReadOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import API_ROUTES from '../../api';

const { Title, Text, Paragraph } = Typography;

export default function Publications() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        axios.get(API_ROUTES.api_publication_list)
            .then(res => {
                if (res.data.code === 200) {
                    // 按照 orderKey 从大到小排序
                    const sortedData = res.data.data.sort((a, b) => (b.orderKey || 0) - (a.orderKey || 0));
                    setData(sortedData);
                }
            })
            .catch(err => {
                console.error("Failed to fetch publications", err);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    const cardStyle = {
        background: 'white',
        borderRadius: '16px',
        padding: '24px',
        marginBottom: '20px',
        boxShadow: '0 4px 15px rgba(0,0,0,0.05)',
        transition: 'all 0.3s ease',
        border: '1px solid #f0f0f0',
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
    };

    return (
        <div className="shared-hero-page" style={{ backgroundColor: '#f9fbff', minHeight: '100vh', paddingBottom: '80px' }}>
            {/* Hero Section */}
            <div className="shared-hero-banner publications-hero-banner" style={{
                padding: '80px 20px 60px',
                textAlign: 'center',
                color: 'white',
                marginBottom: '40px',
                position: 'relative',
                overflow: 'hidden'
            }}>
                <div style={{ position: 'relative', zIndex: 2 }}>
                    <Title level={1} style={{ color: 'white', fontSize: 'clamp(2.5rem, 5vw, 3.5rem)', fontWeight: 800, marginBottom: '16px' }}>
                        Publications
                    </Title>
                </div>
            </div>

            <Row justify={'center'}>
                <Col xs={22} sm={22} md={20} lg={16}>
                    {loading ? (
                        <div style={{ textAlign: 'center', padding: '100px 0' }}>
                            <Spin size="large" />
                        </div>
                    ) : (
                        <List
                            dataSource={data}
                            split={false}
                            locale={{ emptyText: <Empty description="No publications found" /> }}
                            renderItem={(item, index) => (
                                <div
                                    style={cardStyle}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-5px)';
                                        e.currentTarget.style.boxShadow = '0 12px 24px rgba(0,0,0,0.1)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.05)';
                                    }}
                                >
                                    <Row gutter={[24, 16]} align="middle">
                                        <Col xs={24} md={18}>
                                            <Space direction="vertical" size={12} style={{ width: '100%' }}>
                                                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                                                    <div style={{
                                                        backgroundColor: '#e6f4ff',
                                                        color: '#055878',
                                                        padding: '4px 12px',
                                                        borderRadius: '8px',
                                                        fontWeight: 800,
                                                        fontSize: '16px'
                                                    }}>
                                                        {item.orderKey}
                                                    </div>
                                                    <Title level={4} style={{ color: '#055878', margin: 0, lineHeight: 1.4 }}>
                                                        {item.publicationName}
                                                    </Title>
                                                </div>

                                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px', color: '#666' }}>
                                                    <Space size={4}>
                                                        <BookOutlined style={{ color: '#13769a' }} />
                                                        <Text strong style={{ color: '#13769a', fontStyle: 'italic' }}>{item.journal}</Text>
                                                    </Space>

                                                    {item.page && (
                                                        <Space size={4}>
                                                            <ReadOutlined />
                                                            <Text type="secondary">
                                                                {item.page}
                                                            </Text>
                                                        </Space>
                                                    )}

                                                    {item.year && (
                                                        <Space size={4}>
                                                            <CalendarOutlined />
                                                            <Text type="secondary">{item.year}</Text>
                                                        </Space>
                                                    )}

                                                    {item.pmid && (
                                                        <Tag color="blue" bordered={false} style={{ margin: 0, fontWeight: 500 }}>
                                                            PMID: {item.pmid}
                                                        </Tag>
                                                    )}
                                                </div>

                                                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', marginTop: '4px' }}>
                                                    <IdcardOutlined style={{ color: '#888', marginTop: '4px' }} />
                                                    <Text style={{ color: '#555', fontSize: '15px', fontWeight: 500 }}>
                                                        {item.author}
                                                    </Text>
                                                </div>
                                            </Space>
                                        </Col>

                                        <Col xs={24} md={6} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                                            {item.downloadLink && (
                                                <Button
                                                    type="primary"
                                                    icon={<DownloadOutlined />}
                                                    size="large"
                                                    href={item.downloadLink}
                                                    target="_blank"
                                                    style={{
                                                        borderRadius: '12px',
                                                        height: '48px',
                                                        padding: '0 24px',
                                                        background: '#055878',
                                                        border: 'none',
                                                        fontWeight: 600,
                                                        boxShadow: '0 4px 10px rgba(5, 88, 120, 0.2)',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}
                                                    onMouseEnter={(e) => e.currentTarget.style.background = '#13769a'}
                                                    onMouseLeave={(e) => e.currentTarget.style.background = '#055878'}
                                                >
                                                    Full Text PDF
                                                </Button>
                                            )}
                                        </Col>
                                    </Row>
                                </div>
                            )}
                        />
                    )}
                </Col>
            </Row>
        </div>
    );
}

